import axios from "axios";
import { makeRequest } from "./utils";

export const queryAllByIds = async (ids) => {
  const query = `
    query VariantsByIds($ids: [QueryArgument]) {
      variants(id: $ids) {
        id
        sku
        isAvailable
        price
        salePrice
        product {
          title
          productTypeHandle
        }
        ... on paint_Variant {
          id
          paintColour {
            ... on colour_Category {
              id
              accent
              title
              colour
              textColour
            }
          }
          price
          salePrice
          paintSheen {
            id
            title
            slug
          }
          size {
            id
            title
            slug
          }
        }
        ... on coating_Variant {
          id
          coatingSheen {
            id
            title
            slug
          }
          coatingColour {
            ... on coatingColour_Category {
              id
              image @transform(width: 200, immediately: true) {
                id
                url
              }
              title
              slug
            }
          }
          size {
            id
            title
            slug
          }
        }
        ... on supplementary_Variant {
          id
          price
          salePrice
          productTitle
          title
          size {
            id
            title
            slug
          }
        }
        ... on supplies_Variant {
          id
          productTitle
          title
          price
          salePrice
        }
      }
    }  
  `;
  const response = await axios(
    makeRequest(query, {
      ids,
    })
  );

  return response.data.data;
};

export const queryPaints = async (productId, colourId, sheenId, sizeId) => {
  const query = `
    query PaintVariant($productId: [QueryArgument], $paintColour: [QueryArgument], $size: [QueryArgument], $paintSheen: [QueryArgument]) {
      variant(productId: $productId, paintColour: $paintColour, paintSheen: $paintSheen, size: $size) {
        id
        sku
        isAvailable
        price
        salePrice
      }
    }
  `;

  const response = await axios(
    makeRequest(query, {
      productId,
      paintColour: colourId,
      paintSheen: sheenId,
      size: sizeId,
    })
  );

  return response.data.data;
};

export const queryPaintVariants = async (productId, colourId) => {
  const query = `
    query PaintVariants($productId: [QueryArgument], $paintColour: [QueryArgument]) {
      variants(productId: $productId, paintColour: $paintColour, hasStock: true) {
        id
        isAvailable
        price
        salePrice
        product {
          title
          productTypeHandle
        }
        ... on paint_Variant {
            id
            price
            salePrice
            paintSheen {
              id
              title
              slug
            }
            size {
              id
              title
              slug
            }
          }
      }
    }
  `;

  const response = await axios(
    makeRequest(query, {
      productId,
      paintColour: colourId,
    })
  );

  return response.data.data;
};

export const queryCoatings = async (productId, colourId, sheenId, sizeId) => {
  const query = `
    query CoatingVariant($productId: [QueryArgument], $coatingColour: [QueryArgument], $size: [QueryArgument], $coatingSheen: [QueryArgument]) {
      variant(productId: $productId, coatingColour: $coatingColour, coatingSheen: $coatingSheen, size: $size) {
        id
        sku
        isAvailable
        price
        salePrice
      }
    }
  `;

  const response = await axios(
    makeRequest(query, {
      productId,
      coatingColour: colourId,
      coatingSheen: sheenId,
      size: sizeId,
    })
  );

  return response.data.data;
};

export const queryCoatingVariants = async (productId, colourId) => {
  const query = `
      query CoatingVariants($productId: [QueryArgument], $coatingColour: [QueryArgument]) {
        variants(productId: $productId, coatingColour: $coatingColour, hasStock: true) {
          id
          isAvailable
          price
          salePrice
          product {
            title
            productTypeHandle
          }
          ... on coating_Variant {
              id
              price
              salePrice
              coatingSheen {
                id
                title
                slug
              }
              size {
                id
                title
                slug
              }
            }
        }
    }
  `;

  const response = await axios(
    makeRequest(query, {
      productId,
      coatingColour: colourId,
    })
  );

  return response.data.data;
};

export const querySupplementaries = async (productId, sizeId) => {
  const query = `
    query SupplementaryVariant($productId: [QueryArgument], $size: [QueryArgument]) {
      variant(productId: $productId, size: $size) {
        id
        sku
        isAvailable
        price
        salePrice
      }
    }
  `;

  const response = await axios(
    makeRequest(query, {
      productId,
      size: sizeId,
    })
  );

  return response.data.data;
};

export const queryPaintTestPots = async (productId, colourId) => {
  const query = `
    query PaintTestPots($productId: [QueryArgument], $paintColour: [QueryArgument]) {
      variants(productId: $productId, paintColour: $paintColour) {
        id
        title
        productId
        isAvailable
        salePrice
        ... on paintTestPots_Variant {
            id
            sku
            price
            paintColour {
              id
              title
              slug
              ... on paintColour_Category {
                colour
                textColour
              }
            }
        }
      }
    }
  `;

  const response = await axios(
    makeRequest(query, {
      productId,
      paintColour: colourId,
    })
  );

  return response.data.data;
};

export const queryCoatingTestPots = async (productId, colourId) => {
  const query = `
    query CoatingTestPots($productId: [QueryArgument], $coatingColour: [QueryArgument]) {
      variants(productId: $productId, coatingColour: $coatingColour) {
        id
        title
        productId
        isAvailable
        salePrice
        ... on coatingTestPots_Variant {
            sku
            price
            coatingSheen {
              id
              title
              slug
            }
            coatingColour {
              id
              title
              slug
              ... on paintColour_Category {
                colour
                textColour
              }
            }
        }
      }
    }
  `;

  const response = await axios(
    makeRequest(query, {
      productId,
      coatingColour: colourId,
    })
  );

  return response.data.data;
};

export const queryPaintTestPotProductId = async () => {
  const query = `
    query PaintTestPotProductId {
      globalSets {
        ...on gloablProducts_GlobalSet {
          globalPaintTestPotProduct {
            id
          }
        }
      }
    }
  `;

  const response = await axios(makeRequest(query));

  return response.data.data;
};
